import React from 'react';
import Icon from '../Icon/Icon';
import MultiSelectFilter from '../MultiSelectFilter/MultiSelectFilter';
import type { MultiSelectOption } from '../MultiSelectFilter/MultiSelectFilter';
import styles from './SearchFilterBar.module.css';

interface MultiFilterConfig {
  values: string[];
  onChange: (values: string[]) => void;
  options: MultiSelectOption[];
  placeholder?: string;
  extraContent?: (selectedValues: string[]) => React.ReactNode;
}

interface SearchFilterBarProps {
  searchValue: string;
  onSearchChange: (value: string) => void;
  searchPlaceholder?: string;
  multiFilters?: MultiFilterConfig[];
  /** @deprecated Loading indicator was removed; kept for backward-compatible props. */
  loading?: boolean;
  className?: string;
  searchWrapperClassName?: string;
  inputClassName?: string;
}

const SearchFilterBar: React.FC<SearchFilterBarProps> = ({
  searchValue,
  onSearchChange,
  searchPlaceholder = 'Pesquisar',
  multiFilters,
  className = '',
  searchWrapperClassName = '',
  inputClassName = '',
}) => (
  <div className={[styles['filters-row'], className].filter(Boolean).join(' ')}>
    <div className={[styles['search-wrapper'], searchWrapperClassName].filter(Boolean).join(' ')}>
      <Icon name="search" className={styles['search-icon']} />
      <input
        type="text"
        placeholder={searchPlaceholder}
        className={[styles['filter-input'], inputClassName].filter(Boolean).join(' ')}
        value={searchValue}
        onChange={(e) => onSearchChange(e.target.value)}
        autoComplete="off"
      />
    </div>
    {multiFilters?.map((filter, idx) => (
      <MultiSelectFilter
        key={idx}
        values={filter.values}
        onChange={filter.onChange}
        options={filter.options}
        placeholder={filter.placeholder}
        extraContent={filter.extraContent}
        clearButtonLabel="Limpar filtro"
      />
    ))}
  </div>
);

export default SearchFilterBar;
